// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer-copyrights__section[data-v-0fb9bde2]{display:flex;flex-direction:column;gap:var(--spacing-xl-1);width:100%}.footer-copyrights__text[data-v-0fb9bde2]{font-size:var(--font-size-sm-3);padding:0}.footer-copyrights--checkout[data-v-0fb9bde2]{background-color:var(--color-primary-4);color:var(--color-white);padding:var(--spacing-md-3)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
